/* tslint:disable */
import Marionette from "../../shared/marionette-mustache";
import {backboneViewProperties} from "../../decorators/backbone-properties";
import "spin/dist/spin";
require("../plugins/full-screen-thinker.less");

const template = require<string>("../plugins/full-screen-thinker.html");

@backboneViewProperties({
    template: template
})
export class FullScreenThinker extends Marionette.ItemView<Backbone.Model> {
   
    constructor(public model: Backbone.Model) {
        super();
        this.setupModelListeners();
    }

    public onShow() {
        var opts = { lines: 13, length: 20, width: 2, radius: 20, corners: 1, rotate: 0, rection: 1, color: '#ffffff', speed: 1.1, trail: 74, shadow: false, hwaccel: true, className: 'spinner', zIndex: 2e9, top: 'auto', left: 'auto' };
        var spinner = new Spinner(opts).spin();
        this.$(".big-thinker").empty().append(spinner.el);
    }

    private messageChanged(model: Backbone.Model, property: string) {
        var $message = this.$(".message");
        $message.fadeOut(()=>{
            $message.text(property).fadeIn();
        }) 
    }

    private setupModelListeners() {
        this.listenTo(this.model, "change:Message", this.messageChanged);
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/shared/plugins/full-screen-thinker.ts